export default __webpack_public_path__ + "static/media/appheaderimg.e0351103.jpg";